const LOGIN_CONSTANTS = {
  ERROR: 'Ocurrió un error, inténtelo más tarde',
};

export default LOGIN_CONSTANTS;
